(function (window, document) {
    'use strict';

    var loading = false;

    function appendRows(results, html) {
        var container = document.createElement(results.getAttribute('data-music-library-results') === 'list' ? 'tbody' : 'div');

        container.innerHTML = html;

        if (!container.children.length) {
            throw new Error('The next Music Library batch was empty.');
        }

        while (container.firstChild) {
            results.appendChild(container.firstChild);
        }
    }

    function refreshAnimations() {
        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
            window.AOS.refreshHard();
        }
    }

    function restoreLink(link) {
        link.removeAttribute('aria-disabled');
        link.classList.remove('is-loading');
    }

    function loadMore(link) {
        var control = link.closest('[data-music-library-load-more]');
        var results = document.getElementById(link.getAttribute('aria-controls'));
        var status = control && control.querySelector('[data-music-library-load-more-status]');
        var requestUrl = link.getAttribute('data-music-library-load-more-url');
        var fallbackUrl = link.href;

        if (!control || !results || !requestUrl || loading) {
            return;
        }

        if (typeof window.fetch !== 'function') {
            window.location.assign(fallbackUrl);
            return;
        }

        loading = true;
        control.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('is-loading');

        window.fetch(requestUrl, {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('The next Music Library batch could not be loaded.');
            }

            return response.json();
        }).then(function (payload) {
            if (!payload
                || typeof payload.html !== 'string'
                || typeof payload.count !== 'number'
                || typeof payload.has_more !== 'boolean'
                || (payload.has_more && (typeof payload.next_url !== 'string' || typeof payload.fallback_url !== 'string'))) {
                throw new Error('The next Music Library batch was invalid.');
            }

            if (payload.count > 0) {
                appendRows(results, payload.html);
                refreshAnimations();
                document.dispatchEvent(new Event('ikson:music-library-tracks-updated'));
            }

            if (status) {
                status.textContent = payload.count + ' more ' + (payload.count === 1 ? 'track' : 'tracks') + ' loaded.';
            }

            if (!payload.has_more) {
                results.setAttribute('tabindex', '-1');
                results.focus();
                control.remove();
                return;
            }

            link.href = payload.fallback_url;
            link.setAttribute('data-music-library-load-more-url', payload.next_url);
            restoreLink(link);
        }).catch(function () {
            window.location.assign(fallbackUrl);
        }).finally(function () {
            loading = false;

            if (control.isConnected) {
                control.removeAttribute('aria-busy');
            }
        });
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest('[data-music-library-load-more-link]');

        if (!link
            || event.defaultPrevented
            || event.button !== 0
            || event.metaKey
            || event.ctrlKey
            || event.shiftKey
            || event.altKey) {
            return;
        }

        event.preventDefault();

        if (link.getAttribute('aria-disabled') === 'true') {
            return;
        }

        loadMore(link);
    });
})(window, document);
